module.exports = __webpack_public_path__ + "img/agp-logo-new.2a1d7a5c.svg";